import { createSelector } from 'reselect'

export const dhiStateSelector = state => state.dhi
export const dhiSelector = createSelector(dhiStateSelector)
